import WorkspaceUsersView from '../components/workspace/WorkspaceUsersView';

import { useAuthSession } from 'src/auth/hooks/useAuthSession';

const WORKSPACE_ADMIN_ROLES = [
  'TENANT_OWNER',
  'TENANT_ADMIN',
  'TENANT_MANAGER',
  'COMPANY_ADMIN',
  'COMPANY_MANAGER',
];

const WorkspaceUsersPage: React.FC = () => {
  const { workspaceContext } = useAuthSession();

  const canView =
    workspaceContext?.roles.some((r) => WORKSPACE_ADMIN_ROLES.includes(r)) ??
    false;

  if (!canView) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm font-medium text-gray-900">Access Denied</p>
        <p className="mt-1 text-sm text-gray-500">
          You do not have permission to view workspace users.
        </p>
      </div>
    );
  }

  return <WorkspaceUsersView />;
};

export default WorkspaceUsersPage;
